
// import * as mdb from 'mdb-ui-kit'; // lib
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useNavigate, useSearchParams } from "react-router-dom";
import { Trans, useTranslation } from 'react-i18next';
import { MDBBtn, MDBInput } from 'mdb-react-ui-kit';
import { Alert } from '../components/Alert';
import API from '../service/api';
import { TextInput } from '../components/core/inputs/TextInput';
import { PasswordInput } from '../components/core/inputs/PasswordInput';

export const JoinPage = ({onLogin}) => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [searchParams] = useSearchParams();
    const invitationId = useMemo(() => searchParams.get('invitationId'), [searchParams]);
    const [invitation, setInvitation] = useState(null);
    const [password, setPassword] = useState('');
    const [passwordError, setPasswordError] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [name, setName] = useState('');
    const [phone, setPhone] = useState('');
    const [loading, setLoading] = useState(false);
    
    useEffect(() => {
        API.GET(`/r/join/${invitationId}`)
            .then(setInvitation)
            .catch(() => navigate('/'));
    }, [searchParams]);

    const cancelHandler = useCallback(async () => {
        setLoading(true);
        try {
            await API.POST(`/r/join/cancel/${invitationId}`);
            navigate('/');
        }catch(err){
            alert(err.message);
        }finally{
            setLoading(false);
        }
    }, [invitationId]);

    const joinHandler = useCallback(async () => {
        if (invitation.status == 'createUser' && password !== confirmPassword) return setPasswordError(t('password_nomatch_error'));

        setLoading(true);
        try {
            await API.POST(`/r/join/confirm/${invitationId}`, { Name: name, phone, password });
            onLogin();
            localStorage.setItem('newUser', '1');
            navigate('/');
        }catch(err){
            setPasswordError(err.message);
        }finally{
            setLoading(false);
        }
    }, [password, confirmPassword, invitationId, invitation, name, phone]);

    if (!invitation) return null;
    return (
        <section className="h-100" style={{background: '#eee'}}>
            <div className="container-fluid h-100 ">
                <div className="d-flex justify-content-center align-items-center h-100">
                    <div className='card d-flex position-relative w-100' style={{maxWidth: 500}}>
                        <span className='position-absolute d-flex w-100 justify-content-center' style={{top: '-50px'}}>
                            <span className='rounded-circle p-2 text-primary shadow-3' style={{background: '#ddd4d4'}}><i className="fas fa-door-open fa-3x p-2"/></span>
                        </span>
                        
                        <div className='card-body d-flex flex-column justify-content-center align-items-center' style={{marginTop: 15}}>
                            {invitation.name && <h5 className='mb-0'>{invitation.name}</h5> }
                            {invitation.by && <span className='text-muted'><Trans i18nKey="invited_by" values={{name: invitation.by}}/></span>}
                            {invitation.email && <span className="w-100 mt-2"><TextInput label={t('email')} value={invitation.email} disabled/></span> }
                            {invitation.status === 'createUser' && (<>
                                <span className="w-100 mt-2"><TextInput label={t('fullname')} value={name} onValueChange={setName}/></span>
                                <span className="w-100 mt-2"><TextInput label={t('phone')} value={phone} onValueChange={setPhone}/></span>
                                <span className="w-100 mt-2"><PasswordInput label={t('setpassword')} value={password} onValueChange={setPassword}/></span>
                                <span className="w-100 mt-2"><PasswordInput label={t('confirmpassword')} value={confirmPassword} onValueChange={setConfirmPassword}/></span>
                                <Alert type="danger" message={passwordError}/>

                                <div className='d-flex flex-row mt-2 w-100'>
                                    <MDBBtn className='w-50 me-1' disabled={loading} onClick={cancelHandler}>{t('cancel')}</MDBBtn>
                                    <MDBBtn className='w-50 ms-1' color='success' disabled={loading} onClick={joinHandler}>{t('join')}</MDBBtn>
                                </div>
                                
                            </>)}

                            {invitation.status === 'validatePassword' && (<>
                                <PasswordInput label={t('password')} value={password} onValueChange={setPassword}/>
                                <Alert type="danger" message={passwordError}/>

                                <div className='d-flex flex-row mt-2 w-100'>
                                    <MDBBtn className='w-50 me-1' disabled={loading} onClick={cancelHandler}>{t('cancel')}</MDBBtn>
                                    <MDBBtn className='w-50 ms-1' color='success' disabled={loading} onClick={joinHandler}>{t('join')}</MDBBtn>
                                </div>
                            </>)}

                            {invitation.status === 'confirm' && (<>
                                <MDBBtn className='w-50 ms-1' color='success' disabled={loading} onClick={joinHandler}>{t('join')}</MDBBtn>
                            </>)}

                            {invitation.error && (
                            <div>
                                <Alert type="danger" message={invitation.error}/>
                                <MDBBtn className='w-100' onClick={() => navigate('/')}>{t('cancel')}</MDBBtn>
                            </div>)}
                        </div>
                    </div>
                </div>
            </div>
            
            
        </section>
    )
}